import React, { useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const images = [
    '/images/informaticaCover.png',
    '/images/afbeelding.png',
    '/images/eray2.png',
    '/images/grouppic_joe.jpeg',
    '/images/bassEray.jpg',
    '/images/firstperformance.jpg',
    '/images/signal-2025-05-09-231213_002.jpeg',
    '/images/cosplay.jpg',
    '/images/guitarHand.png',
];

const SlideShow = () => {
    const [fullscreenImg, setFullscreenImg] = useState(null);
    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 3,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    return (
        <div className="image-slider-wrapper">
            <Slider {...settings}>
                {images.map((src, index) => (
                    <div key={index}>
                        <img
                            src={src}
                            alt={`Eray ${index}`}
                            className="slider-image"
                            style={{ cursor: 'pointer' }}
                            onClick={() => setFullscreenImg(src)}
                        />
                    </div>
                ))}
            </Slider>
            {fullscreenImg && (
                <div className="fullscreen-modal" onClick={() => setFullscreenImg(null)}>
                    <div className="fullscreen-modal-content" onClick={e => e.stopPropagation()}>
                        <button className="fullscreen-modal-close" onClick={() => setFullscreenImg(null)}>&times;</button>
                        <img src={fullscreenImg} alt="Fullscreen" className="fullscreen-image" />
                    </div>
                </div>
            )}
        </div>
    );
};

export default SlideShow;
